import {is_function} from '../../../../Helpers/js/simple.functions';

export class DropdownQuestion {
  constructor(questionNode, onChange) {
    this.dropdownElement = questionNode.querySelector('select');
    this.dataLabel = this.dropdownElement.getAttribute('data-label');
    this.options = questionNode.querySelectorAll('option');
    this.onChangeOriginal = onChange;
    this.init();
  }

  init() {
    this.dropdownElement.value && this.handleSelectOption('option_' + this.dropdownElement.value);
    this.dropdownElement.addEventListener('change', this.handleDropdownChange.bind(this));
  }

  handleSelectOption(optionId) {
    const option = this.dropdownElement.querySelector('#' + optionId);
    option.setAttribute('aria-selected', true);
    option.setAttribute('selected', 'selected');

    this.dropdownElement.setAttribute('aria-activedescendant', optionId);
    this.dropdownElement.setAttribute('aria-label', this.dataLabel.replace('%s', option.innerText));
  }

  handleDeselectOption() {
    this.dropdownElement.querySelector('option[aria-selected]')?.removeAttribute('aria-selected');
    this.dropdownElement.querySelector('option[selected]')?.removeAttribute('selected');
  }

  handleDropdownChange(e) {
    const selectedOptionId = 'option_' + e.target.value;
    this.handleDeselectOption();
    this.dropdownElement.setAttribute('aria-activedescendant', selectedOptionId);
    this.handleSelectOption(selectedOptionId);
    if (is_function(this.onChangeOriginal)) {
      this.onChangeOriginal();
    }
  }
}
